<template>
  <div>
    <query-form label-width="120px">
      <template v-slot:formitem>
        <query-form-item :label="$t('common.orderLineNo')">
          <el-input clearable v-model="queryForm.boutiqueId"></el-input>
        </query-form-item>
      </template>
      <template>
        <el-button class="mb20" type="primary" @click="search">{{ $t('common.search') }}</el-button>
        <el-button class="mb20" type="info" @click="reset">{{ $t('common.reset') }}</el-button>
      </template>
    </query-form>

    <el-table class="spacing-table" v-loading="loading" :data="tableData">
      <el-table-column :label="$t('common.orderLineNo')" min-width="120">
        <template slot-scope="scope">
          <el-link type="primary" @click="showOrderJSON(scope.row)">{{ scope.row.orderLineNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="boutiqueId" :label="$t('openTools.boutiqueId')" min-width="100"></el-table-column>
      <el-table-column prop="size" :label="$t('common.size')" min-width="100"></el-table-column>
      <el-table-column prop="barcode" :label="$t('openTools.barcode')" min-width="100"></el-table-column>
      <el-table-column :label="$t('openTools.image')" min-width="100">
        <template slot-scope="scope">
          <list-img :img="scope.row.image" :width="40"></list-img>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.status')" min-width="100">
        <template slot-scope="scope">
          {{ $t(`openTools.${scope.row.status}`) }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.createdAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.createdAt | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.createdAt | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.confirmedAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.confirmedAt | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.confirmedAt | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.shippedAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.shippedAt | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.shippedAt | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.cancelledAt')" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.cancelledAt | dateFormat('yyyy-MM-dd') }}<br />
          {{ scope.row.cancelledAt | dateFormat('HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('openTools.exceptionStatus')" min-width="100">
        <template slot-scope="scope">
          <span class="red" v-if="scope.row.exceptionStatus === 1">YES</span>
          <el-link type="primary" v-if="scope.row.exceptionStatus === 1" @click="showException(scope.row)">{{ $t('openTools.detail') }}</el-link>
          <span v-if="scope.row.exceptionStatus === 0">NO</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.action')" fixed="right" width="260">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.status === 'Pending'" @click="showConfirmedForm(scope.row)">{{ $t('openTools.confirm') }}</el-link>
          <el-link class="ml10" v-if="scope.row.status === 'Confirmed'" type="primary" @click="showShippedForm(scope.row)">{{
            $t('openTools.ship')
          }}</el-link>
          <el-link class="ml10" v-if="scope.row.status === 'Pending'" type="primary" @click="showCancelledForm(scope.row)">{{
            $t('openTools.cancel')
          }}</el-link>
          <el-link
            class="ml10"
            v-if="scope.row.status == 'Pending' || scope.row.status === 'Confirmed'"
            type="primary"
            @click="cancelImOrder(scope.row)"
            >{{ $t('openTools.cancelIMOrder') }}</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog :title="$t('openTools.confirm')" :visible.sync="dialogVisible" width="400px">
      <el-form ref="form" :model="confirmedForm" label-width="120px">
        <el-form-item :label="isen ? 'Order Line Num' : '订单号'">
          <el-input v-model="confirmedForm.orderLineNum" disabled></el-input>
        </el-form-item>
        <el-form-item :label="isen ? 'Stock Location' : '仓库'" :rules="[{ required: true, message: 'Please select the stock location' }]">
          <el-select v-model="confirmedForm.stockLocationId" @change="changeStockLocation" style="width: 100%">
            <el-option
              v-for="item in stockLocations"
              :key="item.stockLocationId"
              :label="item.stockLocation"
              :value="item.stockLocationId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <vue-json-pretty :data="confirmedForm"></vue-json-pretty>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitConfirmed">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('openTools.ship')" :visible.sync="dialogVisible2" width="400px">
      <el-form ref="form" :model="shippedForm" label-width="130px">
        <el-form-item :label="isen ? 'Order Line Num' : '订单号'">
          <el-input v-model="shippedForm.orderLineNum" disabled></el-input>
        </el-form-item>
        <el-form-item :label="isen ? 'Tracking Number' : '物流单号'" :rules="[{ required: true, message: 'Please enter the tracking number' }]">
          <el-input v-model="shippedForm.trackingNumber"></el-input>
        </el-form-item>
        <el-form-item :label="isen ? 'Logistics type' : '物流类型'" :rules="[{ required: true, message: 'Please select the logistics type' }]">
          <el-select v-model="shippedForm.logisticsTypeId" style="width: 100%">
            <el-option v-for="item in logisticsTypes" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <vue-json-pretty :data="shippedForm"></vue-json-pretty>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitShipped">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('openTools.cancel')" :visible.sync="dialogVisible3" width="400px">
      <el-form ref="form" :model="cancelledForm" label-width="120px">
        <el-form-item :label="isen ? 'Order Line Num' : '订单号'">
          <el-input v-model="cancelledForm.orderLineNum" disabled></el-input>
        </el-form-item>
        <el-form-item :label="isen ? 'Reason' : '原因'" :rules="[{ required: true, message: 'Please select the reason for failure' }]">
          <el-select v-model="cancelledForm.reasonCode" style="width: 100%">
            <el-option v-for="item in cancelReasonList" :key="item.code" :label="item.value" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <vue-json-pretty :data="cancelledForm"></vue-json-pretty>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="submitCancelled">{{ $t('common.ok') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('openTools.order')" :visible.sync="dialogVisible4" width="600px">
      <vue-json-pretty :data="orderJson"></vue-json-pretty>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('openTools.exceptionDetail')" :visible.sync="dialogVisible5" width="600px">
      <el-table v-loading="loadingException" :data="exceptionTableData">
        <el-table-column :label="$t('openTools.time')">
          <template slot-scope="scope">{{ scope.row.createdAt | dateFormat('yyyy-MM-dd HH:mm:ss') }}</template>
        </el-table-column>
        <el-table-column prop="comments" :label="$t('openTools.type')"></el-table-column>
        <el-table-column prop="description" :label="$t('openTools.reason')"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import ListImg from '../../components/ListImg';
import {
  getOrderList,
  getStockLocation,
  confirmedOrder,
  shippedOrder,
  getCancelReasonCodes,
  cancelledOrder,
  getLogisticsTypes,
  cancelIMOrder,
  getExceptionByOrderLineNum,
} from '../../api/openTools';

export default {
  name: 'OpenToolsOrder',
  components: {
    VueJsonPretty,
    ListImg,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      isen: false,
      queryForm: {
        orderLineNum: null,
        pageNo: 1,
        pageSize: 25,
      },
      stockLocations: [],
      dialogVisible: false,
      confirmedForm: {
        orderLineNum: null,
        stockLocation: null,
        stockLocationId: null,
      },
      logisticsTypes: [],
      dialogVisible2: false,
      shippedForm: {
        orderLineNum: null,
        logisticsTypeId: null,
        trackingNumber: null,
      },
      cancelReasonList: [],
      dialogVisible3: false,
      cancelledForm: {
        orderLineNum: null,
        reasonCode: null,
      },
      orderJson: null,
      dialogVisible4: false,
      dialogVisible5: false,
      loadingException: false,
      exceptionTableData: [],
    };
  },
  created() {
    getStockLocation().then((res) => {
      this.stockLocations = res.data || [];
    });
    getCancelReasonCodes().then((res) => {
      this.cancelReasonList = res.data || [];
    });
    getLogisticsTypes().then((res) => {
      this.logisticsTypes = res.data || [];
    });
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.orderLineNum = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      getOrderList(this.queryForm).then((res) => {
        if (res.success) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
        this.loading = false;
      });
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    showConfirmedForm(row) {
      this.confirmedForm.orderLineNum = row.orderLineNum;
      this.confirmedForm.stockLocation = null;
      this.confirmedForm.stockLocationId = null;
      this.dialogVisible = true;
    },
    changeStockLocation() {
      this.stockLocations.some((item) => {
        if (item.stockLocationId === this.confirmedForm.stockLocationId) {
          this.confirmedForm.stockLocation = item.stockLocation;
          return true;
        }
        return false;
      });
    },
    submitConfirmed() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      confirmedOrder(this.confirmedForm)
        .then((res) => {
          if (res.success) {
            this.dialogVisible = false;
            this.$message.success('Order confirmed');
            this.getTableData();
          } else {
            this.$message.error(res.message || this.$t('error.systemerror'));
          }
          this.repeatSubmit = false;
        })
        .catch(() => {
          this.repeatSubmit = false;
        });
    },
    showShippedForm(row) {
      this.shippedForm.orderLineNum = row.orderLineNum;
      this.shippedForm.logisticsTypeId = null;
      this.shippedForm.trackingNumber = null;
      this.dialogVisible2 = true;
    },
    submitShipped() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      shippedOrder(this.shippedForm)
        .then((res) => {
          if (res.success) {
            this.dialogVisible2 = false;
            this.$message.success('Order shipped');
            this.getTableData();
          } else {
            this.$message.error(res.message || this.$t('error.systemerror'));
          }
          this.repeatSubmit = false;
        })
        .catch(() => {
          this.repeatSubmit = false;
        });
    },

    showCancelledForm(row) {
      this.cancelledForm.orderLineNum = row.orderLineNum;
      this.cancelledForm.reasonCode = null;
      this.dialogVisible3 = true;
    },
    submitCancelled() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      cancelledOrder(this.cancelledForm)
        .then((res) => {
          if (res.success) {
            this.dialogVisible3 = false;
            this.$message.success('Order cancelled');
            this.getTableData();
          } else {
            this.$message.error(res.message || this.$t('error.systemerror'));
          }
          this.repeatSubmit = false;
        })
        .catch(() => {
          this.repeatSubmit = false;
        });
    },
    showOrderJSON(row) {
      this.orderJson = row;
      this.dialogVisible4 = true;
    },
    cancelImOrder(row) {
      cancelIMOrder({
        orderLineNum: row.orderLineNum,
      }).then((res) => {
        if (res.success) {
          this.$message.success('Order cancelled');
          this.getTableData();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
    showException(row) {
      this.loadingException = true;
      this.exceptionTableData = [];
      this.dialogVisible5 = true;
      getExceptionByOrderLineNum({
        orderLineNum: row.orderLineNum,
      }).then((res) => {
        if (res.success) {
          this.exceptionTableData = res.data;
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
        this.loadingException = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
